import { useEffect, useMemo, useState } from "react";

import styles from "./ViewChecklistRow.module.css";
import srdStles from "../../sharedStyles/QuestionsListPagesRow.module.css";
import InfoIconWithTooltip from "../../UI/InfoIconWithTooltip/InfoIconWithTooltip";

const ViewChecklistRow = (props) => {
  const [displayButtons, setDisplayButtons] = useState(false);
  const [selectedOpScopeAnswer, setSelectedOpScopeAnswer] = useState(props.opScopes);
  const [note, setNote] = useState(props.note);
  
  const [opScopesVisibility, setOpScopesVisibility] = useState();
  const qualitativeAnswers = useMemo(() => props.qualitativeAnswers, []);
  const [isInfoIconVisible, setIsInfoIconVisible] = useState(false);
  
  useEffect(() => {
    setNote(props.note);
    if (props.questionType && (props.questionType === "qualitative")) {
      const opScopesVisibilityArray = props.opScopes.map( _ => false);
      setOpScopesVisibility(opScopesVisibilityArray)
    }
  }, [props]);

  const showElementButtons = (e) => {
    e.preventDefault();
    setDisplayButtons(true);
  };

  const hideElementButtons = (e) => {
    e.preventDefault();
    setDisplayButtons(false);
  };

  const showInfoIcon = (e) => {
    e.preventDefault();
    setIsInfoIconVisible(true);
  };

  const hideInfoIcon = (e) => {
    e.preventDefault();
    setIsInfoIconVisible(false);
  };

  let title = props.title;
  let titleStyle = "";
  let type = props.type;
  let pos = props.pos; // position/index of row in the array
  if (type === "principio") titleStyle = styles.principio;
  else if (type === "requisito") titleStyle = styles.requisito;
  else if (type === "ambito") titleStyle = styles.ambito;

  const determineAnswerType = (answerType) => {
    switch(answerType) {
      case "Good":
        return "good"
      case "Satisfactory":
        return "satisfactory"
      case "Unsatisfactory":
        return "unsatisfactory"
      case "Poor":
        return "poor"
      case "N/A":
        return "n_a"
      default:
    }
  }

  let qualitativeQuestionAnswers = props.questionType && props.questionType === "qualitative" && 
    props.opScopes.map((opScope, opScopeIndex) => {
      return opScope.enabled ? (  
        <td key={pos + "-" + opScope.name} className={styles.opScopeWidth}>
            {opScope.answer ? <div
              className={`${styles.qualAnswer} ${styles[determineAnswerType(opScope.answer)]} nexiColor smallItalic`}
            >
              {opScope.answer}
            </div> 
            : <div
              className={`${styles.qualAnswerNoSelection}`}
            >
              No selection
            </div>}
        </td>
      ) : <td className={`${styles.disabledTd} ${styles.opScopeWidth}`}>N/A</td>
    });

  
    const elementDropdownArrow = (
      <div
        className={`${srdStles.dropdownArrowContainer} overflow-visible p-0`}
      >
        <button
          onClick={
            () => {
              props.collapseElement(pos, !props.isCollapsed)
            }
          }
          className={`${srdStles.dropdownArrow} ${props.isCollapsed ? srdStles.down : srdStles.up} ${displayButtons ? "visible" : "invisible"}`}
        ></button>
      </div>
    );

  return (
    <tr 
      className={`${titleStyle} ${!type && styles.trHover}`}
      onMouseEnter={(e) => {
        showElementButtons(e);
        showInfoIcon(e);
      }}
      onMouseLeave={(e) => {
        hideElementButtons(e);
        hideInfoIcon(e);
      }}
    >
      {/* TITLE*/}
      <td
        className={`  
          ${type && "text-white"} ${styles.questionsWidth}
          ${type && (srdStles.cursorPointer + ' ' + srdStles[`${type}Hover`])} 
          ${props.isCollapsed &&  srdStles[`${type}Valid`]}
          ${/*props.isCollapsed && (props.hasValidChildren ? srdStles[`${type}Valid`] : srdStles[`${type}Invalid`]) */"" }
          fw-bold text-start position-relative px-2
        `}
        data-tip=""
        colSpan={!type ? "1" : props.opScopesList.length + 1}
        onClick={() => {
          if (type) {
            props.collapseElement(pos, !props.isCollapsed);
          }
        }}
      >
      {type && elementDropdownArrow /* excluding ambiti because they have the plus button */}
      {!type ? (
        <div className="d-flex">
          {props.questionType !== "quantitative" ? (
              <div className={`${styles.questionId} ${styles.qltQstDisplayId} pe-2 me-2`}>{props.principioId}.{props.displayId && props.displayId}</div>
            ) : null}
          <textarea defaultValue={title} disabled className={`${styles.qstParagraph} fw-bold m-0`} />
        </div>
        // <p className="m-0" style={{maxHeight: "80px", overflowX: "hidden", overflowY: "scroll"}}>{title}</p>
      ) : (
        <p className="m-0 mb-2"
          style={
            type === "requisito"
              ? { paddingLeft: "7px"}
              : type === "ambito"
              ? { paddingLeft: "14px"}
              : {}
          }
        >
          {title}
        </p>
      )}
      {/* Tooltip */}
      <InfoIconWithTooltip text={props.tooltip} show={isInfoIconVisible} />
      </td>
      {/* EMPTY CELLS FOR NON-QUESTION ELEMENTS */}
      {/* {type && props.osKeys.map( (_, index) => (
        <td className={styles.tdWidth} key={index}></td>
      ))} */}
      {/* QUALITATIVE ANSWERS */}
      {qualitativeQuestionAnswers}
      {/* QUANTITATIVE ANSWERS */}
      {!type && props.questionType === "quantitative" && props.opScopes.map(el => {
        return el.enabled ? <td key={pos + "-" + el.name} className={styles.opScopeWidth}>
            <div className={`${styles.inputNumberField} ${styles.noSpinner}`}>
              {el.answer}
            </div>
        </td> : <td className={styles.disabledTd}>N/A</td>
      })}
      {/* NOTE */}
      <td className={`${!type && styles.note} ${styles.notesWidth}`}>
        {!type && <textarea disabled className={`fw-bold`}>
          {note}
        </textarea>}
        {type && ""}
      </td>
    </tr>
  );
};

export default ViewChecklistRow;
